'use strict';

import TextView from './Text';

class PasswordField extends TextView{
}


export default PasswordField;
